import React, { PropsWithChildren } from 'react';
import Web3EVMProvider from './web3Provider';

const Proviers = ({ children }: PropsWithChildren) => {
  return <Web3EVMProvider>{children}</Web3EVMProvider>;
};

export default Proviers;
